import { log } from '@hotjar/insights-common/lib/log';

/**
 * Facebook related tracking.
 *
 */

const callbacksAfterSetup: Array<() => void> = [];

let initialSetupComplete = false;
let loginTrackingSent = false;

// Wait for Facebook to load, then run any method calls that's been triggered in the meantime.
const intervalId = setInterval(() => {
  if (window.fbq) {
    clearInterval(intervalId);
    initialSetupComplete = true;
    callbacksAfterSetup.forEach((callback) => callback());
  }
}, 100);

/**
 * If Facebook is loaded it simply executes the method call. If not, it will add it to the callback queue.
 * @param callback Method call to either execute or add to queue.
 */
function callOrQueue(callback: () => void) {
  if (initialSetupComplete) {
    callback();
  } else {
    callbacksAfterSetup.push(callback);
  }
}

/**
 * Track that a user has logged in.
 */
export const trackLogin = (): void => {
  callOrQueue(() => {
    if (!loginTrackingSent && window.fbq) {
      log.debug('Facebook: Tracking logged in user');
      window.fbq('trackCustom', 'login', {
        value: 0.0,
        currency: 'USD',
      });
      loginTrackingSent = true;
    }
  });
};

/**
 * Track that a user signed up.
 */
export const trackSignup = (): void => {
  callOrQueue(() => {
    if (window.fbq) {
      log.debug('Facebook: Tracking sign-up');
      window.fbq('trackCustom', 'signup', {
        value: 0.0,
        currency: 'USD',
      });
    }
  });
};

/**
 * Track that a user has become a customer (he has paid us money).
 *
 * @param account Account which became a new customer.
 * @param totalCost The total cost which the user spent on his first purchase.
 */
export const newCustomer = (account: { currency: string }, totalCost: number): void => {
  callOrQueue(() => {
    if (window.fbq) {
      log.debug('Facebook: Tracking new customer');
      // Use the 'track' event as 'Purchase' is a standard event supported by Facebook:
      // https://developers.facebook.com/docs/facebook-pixel/api-reference#events
      window.fbq('track', 'Purchase', {
        value: totalCost,
        currency: account.currency.toUpperCase(),
      });
    }
  });
};
